export default __webpack_public_path__ + "static/media/sabouni.d25b1488.jpg";